import { Providers } from 'modules/SlotsRoot/types/configuration'
import { DigitainSlotToken, DigitainSlotTokenDTO } from 'modules/SlotsRoot/types/interfaces/Slots/DigitainSlot'
import {
  IGetGameListDTO,
  IProducer,
  IProducersList,
  ISlotDTO,
} from 'modules/SlotsRoot/types/interfaces/Slots/GameCatalog'
import { INewGamesDTO, ISlotViewItem, ITopSlotsDTO } from 'modules/SlotsRoot/types/interfaces/Slots/Slots'
import { getAdditionalIntegrationGameId } from 'modules/SlotsRoot/utils/helpers'
import { getGameCatalogImage } from 'modules/SlotsRoot/utils/images'
import { excludeProducersArray, renameProducerForBetshistory } from 'modules/SlotsRoot/utils/slotshistory'

import { IConvertGameList, ISlotConverter } from '../../types/converter'
import { getTabLive } from '../Softswiss/SoftwissUtils'
import {
  blackListGames,
  digitainProvidersBlackList,
  getGameCatalogTab,
  getGameType,
  getSlotProviderName,
  providersWhiteList,
} from './GameCatalogUtils'
import { getPureGameId, uniqGameId } from './uniqGameId'

class GameCatalogConverter implements ISlotConverter {
  convertGameList = ({ data }: IConvertGameList<IGetGameListDTO>): ISlotViewItem[] =>
    data.games
      .map((item: ISlotDTO) => {
        const provider = getSlotProviderName(item)

        return {
          id: String(item.id),
          gameId: uniqGameId(item.integration, provider, item.game_id),
          description: item.description,
          gameName: item.name,
          tab: getGameCatalogTab(item.game_id, item.drops_and_wins),
          tabLive: getTabLive(item.game_id, item.drops_and_wins),
          provider,
          imageUrl: item.image,
          // imageUrl: getGameCatalogImage(item.game_id, item.image, item.image_desktop, 'desktop'),
          routeProvider: item.integration,
          additionalData: {
            system: item.slug.split('/')?.[0],
          },
          additionalIntegrationGameId: getAdditionalIntegrationGameId(item.integration, item),
          hasDemoMode: item.integration === Providers.digitain,
          ...getGameType(item),
        }
      })
      .filter(t => {
        if (t.routeProvider === Providers.digitain) return !digitainProvidersBlackList.includes(t.provider)

        return (
          providersWhiteList.indexOf(t.provider) !== -1 &&
          !(blackListGames.includes(t.gameId) || blackListGames.includes(getPureGameId(t.gameId)))
        )
      })

  convertGameUrl = ({ data }: { data: string }) => data

  convertGameUrlPragmatic = ({ data }: { data: { gameURL: string } }) => data.gameURL

  // eslint-disable-next-line camelcase
  convertGameUrlBcraft = ({ data }: { data: { game_url: string } }) => data.game_url

  convertProducers = (data: IProducersList): IProducer[] => {
    const producers = data.producers
      .filter(
        item => !item?.integrations?.includes('89fa86ca') && !excludeProducersArray.includes(item.name) && item.active,
      )
      .map(item => ({ ...item, name: renameProducerForBetshistory[item.name] || item.name }))

    return producers
  }

  convertDigitainSlotToken(data: DigitainSlotTokenDTO): DigitainSlotToken {
    return data.token
  }

  convertTopSlots = (data: ITopSlotsDTO): string[] => data.games || []

  convertNewGames = (data: INewGamesDTO): string[] => data.games || []
}

export default GameCatalogConverter
